import {
  FORM_ABOUT_PREVIOUS_ADDRESS,
  FORM_DD_BILLING_ADDRESS,
} from '@features/Address/constants';
import { validate as validateAddress } from '@features/Address/validation';
import { BooleanSelection } from '@src/types/index';
import {
  AboutYouFormValues,
  BroadbandFormValues,
  DirectDebitFormValues,
  OTSFormValues,
  ReferralLegalFormValues,
  YourAccountFormValues,
} from '@src/types/yourDetails';

import { validate as validateAboutYou } from './AboutYou/validate';
import { validate as validateBroadband } from './Broadband/validate';
import { validate as validateDirectDebit } from './DirectDebit/validate';
import { validate as validateOTS } from './OneTouchSwitching/validate';
import { validate as validateReferralLegal } from './ReferralLegal/validate';
import { validate as validateYourAccount } from './YourAccount/validate';

const shouldValidateBillingAddress = (
  values: AboutYouFormValues & DirectDebitFormValues
) => {
  return values.ddBillingSame === BooleanSelection.No;
};

const shouldValidatePreviousAddress = (values: AboutYouFormValues) => {
  return (
    values.aboutAddressRecent === BooleanSelection.Yes &&
    values.aboutAddressPreviousOwner === BooleanSelection.Yes
  );
};

type Values = AboutYouFormValues &
  YourAccountFormValues &
  DirectDebitFormValues &
  BroadbandFormValues &
  OTSFormValues &
  ReferralLegalFormValues;

interface Flags {
  isPaperBillingEnabled?: boolean;
  isSelectedBroadbandOnly?: boolean;
  canSwitch?: boolean;
}
const validate = (values: Values, flags: Flags = {}) => {
  const aboutYouErrors = validateAboutYou(
    values,
    flags?.isPaperBillingEnabled ?? false
  );
  const yourAccountErrors = validateYourAccount(values);
  const directDebitErrors = validateDirectDebit(values);
  const referralLegalErrors = validateReferralLegal(values);
  const broadbandErrors = validateBroadband(values, {
    isBroadbandOnly: flags.isSelectedBroadbandOnly,
  });
  const otsErrors = validateOTS(values, flags.canSwitch ?? false);

  let billingAddressErrors = {};
  if (shouldValidateBillingAddress(values)) {
    billingAddressErrors = validateAddress(
      values.ddBillingAddressForm as never,
      FORM_DD_BILLING_ADDRESS
    );
  }

  let previousAddressErrors = {};
  if (shouldValidatePreviousAddress(values)) {
    previousAddressErrors = validateAddress(
      values.aboutPreviousAddress as never,
      FORM_ABOUT_PREVIOUS_ADDRESS,
      false
    );
  }

  return {
    ...aboutYouErrors,
    ...yourAccountErrors,
    ...directDebitErrors,
    ...referralLegalErrors,
    ...billingAddressErrors,
    ...previousAddressErrors,
    ...broadbandErrors,
    ...otsErrors,
  };
};

export { validate };
